<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">x</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Êtes-vous sûr de vouloir replanifier ce rendez-vous ?</h4>
    </div>
    <div class="modal-footer justify-content-center">
      <button type="button"
              class="btn btn-default"
              @click="closeModal">Non, ne pas annuler</button>
      <button type="button"
              class="btn btn-success"
              @click="onConfirm">Oui, replanifier</button>
    </div>
  </div>
</template>

<script>
  import store from '../../config/store'

  export default {
    data: () => ({
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      }
    },

    methods: {
      onConfirm () {
        this.$bus.$emit(`replan-confirm-success`)
      }
    }
  }
</script>
